export default "__VITE_ASSET__XJxISoZb__"